<!-- MonthlySales.vue -->
<script setup lang="ts">
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
import { computed } from 'vue';

// Register Chart.js components
Chart.register(...registerables);

// Props
interface Props {
  height?: number;
  styles?: Record<string, string>;
  data?: number[];
  labels?: string[];
  backgroundColor?: string;
  title?: string;
}

const props = withDefaults(defineProps<Props>(), {
  height: 150,
  styles: () => ({ 
    'margin-left': '0px', 
    'background': '#e8757857' 
  }),
  data: () => [30, 23, 32, 39, 28, 30, 39, 30, 32, 29, 32, 31],
  labels: () => [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ],
  backgroundColor: '#f87979',
  title: 'Monthly Sales'
});

// Chart data
const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      backgroundColor: props.backgroundColor,
      data: props.data,
      borderWidth: 0,
      // For line chart appearance without actual line
      borderColor: 'transparent',
      pointBackgroundColor: 'transparent',
      pointBorderColor: 'transparent'
    }
  ]
}));

// Chart options for Chart.js v3
const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: props.title
    },
    legend: {
      display: false
    },
    // Hide tooltip for this dataset if needed
    tooltip: {
      enabled: false // Or customize as needed
    }
  },
  scales: {
    x: {
      display: false,
      offset: true,
      grid: {
        display: false
      },
      // Hide ticks
      ticks: {
        display: false
      }
    },
    y: {
      display: false,
      grid: {
        display: false
      },
      // Hide ticks
      ticks: {
        display: false
      }
    }
  },
  // Additional options for bar chart
  elements: {
    bar: {
      borderWidth: 0,
      borderRadius: 4, // Rounded corners
      borderSkipped: false as const,
    }
  }
}));

// Container styles
const containerStyle = computed(() => ({
  height: `${props.height}px`,
  ...props.styles
}));

// Expose methods if needed
defineExpose({
  updateData: (newData: number[]) => {
    // This would require using a ref and reactive updates
    console.log('Update data to:', newData);
  }
});
</script>

<template>
  <div :style="containerStyle">
    <BarChart 
      :chart-data="chartData" 
      :options="chartOptions" 
    />
  </div>
</template>